// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `gamification mat-tab-group {
  display: flex;
  justify-content: center;
  flex: 1;
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version. */
}
gamification mat-tab-group .mat-mdc-tab-body-wrapper {
  display: flex;
  justify-content: center;
  flex: 1;
}
gamification mat-tab-group .mat-mdc-tab-body-wrapper .mat-mdc-tab-body {
  position: absolute;
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version. */
}
gamification mat-tab-group .mat-mdc-tab-body-wrapper .mat-mdc-tab-body .mat-mdc-tab-body-content {
  overflow: hidden;
}
gamification mat-tab-group .mat-mdc-tab-body-wrapper .mat-mdc-tab-body .mat-mdc-tab-body-content app-gallery {
  height: 100%;
}
gamification mat-tab-group .mat-mdc-tab-body-wrapper .mat-mdc-tab-body .mat-mdc-tab-body-content app-my-animals {
  height: 100%;
}
gamification .credits {
  position: absolute;
  right: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #24B7C7;
  display: flex;
  align-items: center;
  justify-content: center;
}
gamification .credits > .icon {
  background: rgba(36, 183, 199, 0.8);
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  height: 34px;
  width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
gamification .credits > .icon path {
  color: #fff;
  fill: #fff;
}
gamification .header-tabs {
  display: flex;
}
gamification .header-tabs .tabs {
  display: flex;
  justify-content: center;
  flex: 1;
}
gamification .header-tabs .tabs .tab {
  margin: 20px;
  cursor: pointer;
}
gamification .header-tabs .tabs .tab.active {
  border-bottom: 2px solid turquoise;
}
gamification .header-tabs .credits {
  margin: 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #24B7C7;
  display: flex;
  align-items: center;
  justify-content: center;
}
gamification .header-tabs .credits > .icon {
  background: rgba(36, 183, 199, 0.8);
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  height: 34px;
  width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
gamification .header-tabs .credits > .icon path {
  color: #fff;
  fill: #fff;
}
gamification app-my-animals {
  flex: 1;
}
gamification .spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
gamification app-buy-popup {
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/gamification/core/gamification/gamification.component.scss"],"names":[],"mappings":"AAEI;EACI,aAAA;EACA,uBAAA;EACA,OAAA;EAEA,2HAAA;AAFR;AAGQ;EACI,aAAA;EACA,uBAAA;EACA,OAAA;AADZ;AAGY;EACI,kBAAA;EACA,2HAAA;AADhB;AAEgB;EACI,gBAAA;AAApB;AAEoB;EACI,YAAA;AAAxB;AAGoB;EACI,YAAA;AADxB;AAQI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR;AASQ;EACI,mCAAA;EACA,iDAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAPZ;AASY;EACI,WAAA;EACA,UAAA;AAPhB;AAaI;EACI,aAAA;AAXR;AAaQ;EACI,aAAA;EACA,uBAAA;EACA,OAAA;AAXZ;AAcY;EACI,YAAA;EACA,eAAA;AAZhB;AAcgB;EACI,kCAAA;AAZpB;AAiBQ;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBZ;AAkBY;EACI,mCAAA;EACA,iDAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAhBhB;AAkBgB;EACI,WAAA;EACA,UAAA;AAhBpB;AAuBI;EACI,OAAA;AArBR;AAwBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAtBR;AAyBI;EACI,UAAA;AAvBR","sourcesContent":["gamification {\n\n    mat-tab-group {\n        display: flex;\n        justify-content: center;\n        flex: 1;\n\n        /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version. */\n        .mat-mdc-tab-body-wrapper {\n            display: flex;\n            justify-content: center;\n            flex: 1;\n\n            .mat-mdc-tab-body {\n                position: absolute;\n                /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version. */\n                .mat-mdc-tab-body-content {\n                    overflow: hidden;\n\n                    app-gallery {\n                        height: 100%;\n                    }\n\n                    app-my-animals {\n                        height: 100%;\n                    }\n                }\n            }\n        }\n    }\n\n    .credits {\n        position: absolute;\n        right: 24px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 48px;\n        font-family: Roboto;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 18px;\n\n        color: #24B7C7;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        >.icon {\n            background: rgba(36, 183, 199, 0.8);\n            box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\n            border-radius: 50%;\n            height: 34px;\n            width: 34px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-right: 10px;\n\n            path {\n                color: #fff;\n                fill: #fff;\n            }\n        }\n    }\n\n\n    .header-tabs {\n        display: flex;\n\n        .tabs {\n            display: flex;\n            justify-content: center;\n            flex: 1;\n\n\n            .tab {\n                margin: 20px;\n                cursor: pointer;\n\n                &.active {\n                    border-bottom: 2px solid turquoise;\n                }\n            }\n        }\n\n        .credits {\n            margin: 20px;\n            font-family: Roboto;\n            font-style: normal;\n            font-weight: 500;\n            font-size: 18px;\n\n            color: #24B7C7;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            >.icon {\n                background: rgba(36, 183, 199, 0.8);\n                box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\n                border-radius: 50%;\n                height: 34px;\n                width: 34px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                margin-right: 10px;\n\n                path {\n                    color: #fff;\n                    fill: #fff;\n                }\n            }\n        }\n\n    }\n\n    app-my-animals {\n        flex: 1;\n    }\n\n    .spinner {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n    }\n\n    app-buy-popup {\n        z-index: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
